import { Component, Input, OnInit, EventEmitter, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CsiteSupplier, IssuesFilterSupplier, House } from '@arpada/arp-lib-common-qupro';
import { MessagesService, PortalProveedorService } from '../../../../services/api.services';
import { IssuesProformablesFilterComponentsValues } from '../../../../models/api.models';
import { ActionsSharedData } from '../actions.shared.data';
import { IssuePopulateService } from '../../../../services/populators/issue-populate.service';

@Component({
  selector: 'app-filter-issues-proformables',
  templateUrl: './filter-issues-proformables.component.html',
  styleUrls: ['./filter-issues-proformables.component.scss'],
})
export class FilterIssuesProformablesComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filterForm', { static : true }) filterForm: NgForm;

  @Input() csite: CsiteSupplier;
  @Input() filter: IssuesFilterSupplier;
  @Input() sharedData: ActionsSharedData;
  @Input() filterChange = new EventEmitter();
  @Input() isModal: boolean;

  detectChanges = false;
  portals: string[] = [];
  floors: string[] = [];
  letters: string[] = [];
  houses: House[] = [];
  enviromentSelected = false;
  portalSelected = false;
  floorSelected = false;
  componentsValues: IssuesProformablesFilterComponentsValues = null;

  private modalId: string = null;
  private detectChangesSubscription: Subscription = null;
  private loginRedirectSubscription: Subscription;

  constructor(private portalProveedorService: PortalProveedorService,
              private messages: MessagesService,
              private modalController: ModalController,
              private issuePopulateService: IssuePopulateService
              ) { }

  ngOnInit() {
    this.modalController.getTop().then((top: HTMLIonModalElement) => {
      this.modalId = top.id; // Get modal ID for close it
    });
    this.messages.onInitTranslateService().subscribe( () => {
      this.componentsValues = {
        conform: this.filter ? this.filter.conform : null,
        createDateFrom: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.create_date_from) : null,
        createDateTo: this.filter ? this.issuePopulateService.getStringOfTimestamp(this.filter.create_date_to) : null,
        commonArea: this.filter ? this.filter.common_area : null,
        portal: this.filter ? this.filter.portal : null,
        floor: this.filter ? this.filter.floor : null,
        door: this.filter ? this.filter.letter : null,
        csiteId: this.csite.id
      };
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.detectChanges = true;
      this.detectChangesSubscription = this.filterForm.valueChanges.subscribe(this.onChangeComponent);
    });
  }

  onChangeComponent = () => {
    if (this.detectChanges) {
      setTimeout(() => {
        this.updateFiltro();
      }, 50); // Time to apply filters, after change this.filter
    }
  }

  ngOnDestroy() {
    if (this.detectChangesSubscription) {
      this.detectChangesSubscription.unsubscribe();
    }
    this.detectChanges = false;
    if (this.loginRedirectSubscription) {
      this.loginRedirectSubscription.unsubscribe();
    }
  }

  selectEnvironment() {
    this.portals = [];
    if (this.componentsValues.commonArea || this.componentsValues.commonArea === 0) {
      this.enviromentSelected = true;
      let commonArea = false;
      if (this.componentsValues.commonArea === 1) {
        commonArea = true;
      }
      this.portalProveedorService.getCachedHouses(this.componentsValues.csiteId, commonArea).subscribe(resp => {
        this.houses = resp.elements;
        this.houses.forEach(house => {
          this.portals.push(house.portal);
        });
        this.portals = this.removeDuplicados(this.portals);
      });
    } else {
      this.enviromentSelected = false;
      this.componentsValues.portal = null;
      this.selectPortal();
    }
  }

  removeDuplicados(list: string[]): string[] {
    return list.filter((item, index) => {
      return list.indexOf(item) === index;
    });
  }

  selectPortal() {
    this.floors = [];
    this.portalSelected = false;
    this.componentsValues.floor = null;
    if (this.componentsValues.portal) {
      this.houses.forEach(house => {
        if (this.componentsValues.portal === house.portal) {
          this.floors.push(house.floor);
        }
      });
      this.floors = this.removeDuplicados(this.floors);
      this.portalSelected = true;
    } else {
      this.portalSelected = false;
      this.componentsValues.floor = null;
      this.selectFloor();
    }
  }

  selectFloor() {
    this.letters = [];
    this.floorSelected = false;
    this.componentsValues.door = null;
    if (this.componentsValues.floor) {
      this.houses.forEach(house => {
        if ((this.componentsValues.portal === house.portal) && (this.componentsValues.floor === house.floor)) {
          this.letters.push(house.letter);
        }
      });
      this.letters = this.removeDuplicados(this.letters);
      this.floorSelected = true;
    } else {
      this.floorSelected = false;
      this.componentsValues.door = null;
    }
  }


  updateFiltro() {
    if ( !this.componentsValues ) { return; }
    this.updateConform();
    this.updateHouseOrCommonArea();
    this.updateDates();
    this.filterChange.emit(this.filter);
    this.portalProveedorService.issuesProformablesRowsSelectedEvent.emit('resetea las columnas seleccionadas!!');
  }

  clearDateFilter(dateFilterPropertyKey: string) {
    if (this.componentsValues && this.componentsValues[dateFilterPropertyKey]) {
      this.componentsValues[dateFilterPropertyKey] = null;
      this.updateDates();
    }
  }

  isTotalCountDefined() {
    return this.sharedData && this.sharedData.totalCount
           && this.sharedData.totalCount !== '' && parseInt(this.sharedData.totalCount, 10) >= 0;
  }

  public dismiss() {
    this.detectChanges = false;
    this.modalController.dismiss({
      dismissed: true
    }, null, this.modalId);
  }

  private updateConform() {
    this.filter.conform = this.componentsValues.conform;
  }

  private updateHouseOrCommonArea() {
    this.reloadIfIsNeededHouseOrCommonAreaSelectBox();
    this.filter.common_area = this.componentsValues.commonArea;
    this.filter.portal = this.componentsValues.portal;
    this.filter.floor = this.componentsValues.floor;
    this.filter.letter = this.componentsValues.door;
  }

  private reloadIfIsNeededHouseOrCommonAreaSelectBox() {
    if (this.filter.common_area !== this.componentsValues.commonArea) {
      this.reloadPortalSelect();
    } else if (this.filter.portal !== this.componentsValues.portal) {
      this.reloadFloorSelect();
    } else if (this.filter.floor !== this.componentsValues.floor) {
      this.reloadDoorSelect();
    }
  }

  private reloadPortalSelect() {
    if (this.componentsValues.commonArea === 0) {
      this.loadPortalSelect();
    } else {
      this.portals = null;
    }
    this.componentsValues.portal = null;
    this.componentsValues.floor = null;
    this.componentsValues.door = null;
    this.floors = null;
    this.letters = null;
  }

  private reloadDoorSelect() {
    if (this.componentsValues.floor) {
      this.loadDoorSelect();
    } else {
      this.letters = null;
    }
    this.componentsValues.door = null;
  }

  private loadPortalSelect() {
    this.portals = [];
    for (const house of this.houses) {
      if (house.common_area === this.componentsValues.commonArea &&
          this.portals.indexOf(house.portal) < 0) {
        this.portals.push(house.portal);
      }
    }
    this.portals.sort();
  }

  private reloadFloorSelect() {
    if (this.componentsValues.portal) {
      this.loadFloorSelect();
    } else {
      this.floors = null;
    }
    this.componentsValues.floor = null;
    this.componentsValues.door = null;
    this.letters = null;
  }

  private loadDoorSelect() {
    this.letters = [];
    for (const house of this.houses) {
      if (house.common_area === 0 &&
          house.portal === this.componentsValues.portal &&
          house.floor === this.componentsValues.floor &&
          this.letters.indexOf(house.letter) < 0) {
        this.letters.push(house.letter);
      }
    }
    this.letters.sort();
  }

  private loadFloorSelect() {
    this.floors = [];
    for (const house of this.houses) {
      if (house.common_area === 0 &&
          house.portal === this.componentsValues.portal &&
          this.floors.indexOf(house.floor) < 0) {
        this.floors.push(house.floor);
      }
    }
    this.floors.sort();
  }

  // private getStringOfTimestamp(timestamp: number): string {
  //   let toReturn: string = null;
  //   if (timestamp) {
  //     toReturn = new Date(timestamp).toISOString();
  //     // formatDate( timestamp, 'YYYY-MM-DDThh:mm:ss.sTZD', 'es', '+0100');
  //   }
  //   return toReturn;
  // }

  private updateDates() {
    if (this.componentsValues.createDateFrom) {
      const createDateFrom: Date = new Date(this.componentsValues.createDateFrom);
      createDateFrom.setHours(0, 0, 0, 0);
      this.filter.create_date_from = createDateFrom.getTime();
    } else {
      this.filter.create_date_from = null;
    }
    if (this.componentsValues.createDateTo) {
      const createDateTo: Date = new Date(this.componentsValues.createDateTo);
      createDateTo.setHours(23, 59, 59, 999);
      this.filter.create_date_to = createDateTo.getTime();
    } else {
      this.filter.create_date_to = null;
    }
  }

}
